<template>
  <div class="recommendClass" style="width:100%" v-loading="!loaded">
    <!-- <div class="tag">
      <div class="container">
        <div class="type-box">
          <span class="lable wid">分类：</span>
          <div class="overf-h">
            <a
              :class="['wid','cont',index1==active1?'active':'']"
              v-for="(item, index1) in tag"
              :key="index1"
              @click="choosetype(index1,1)"
            >{{item}}</a>
          </div>
        </div>
      </div>
    </div>-->
    <template v-if="dataTable.length>0">
      <el-row :gutter="15" class="sort overf-h">
        <el-col :span="6" class="sortItem" v-for="(item,index) in dataTable" :key="index">
          <div @click="$router.push({path:'/roomDetail',query:{id:item.id}})">
            <el-card shadow="hover">
              <div class="sort-img">
                <el-image :src="item.thumb_image" lazy class="class-img"></el-image>
              </div>
              <div class="sort-des">{{item.name}}</div>
              <div class="sort-rate overf-h">
                <div class="price-box overf-h">
                  <el-rate :value="item.score-0" disabled :colors="colors" text-color="#505050"></el-rate>
                  <div class="timeArea">{{item.begin_at}}~{{item.end_at}}</div>
                </div>
                <div class="class-box">班级课程</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>

      <div style="margin:20px 0 40px;text-align: center;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[8, 16, 32]"
          :page-size="limit"
          layout=" sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </template>
    <Empty v-if="loaded&&dataTable.length==0" />
  </div>
</template>

<script>
import Empty from "@/components/Empty";
export default {
  name: "OnlineClass",
  components: { Empty },
  data() {
    return {
      colors: ["#33B17B", "#33B17B", "#33B17B"],
      value: "3.8",
      page: 1,
      limit: 8,
      total: 0,
      active1: 0,
      active2: 0,
      active3: 0,
      loaded: false,
      dataTable: [],
      tag: [],
      sort: ["销量", "评分", "上架时间"],
    };
  },

  created() {
    this.getdata();
  },

  methods: {
    getdata() {
      this.$http({
        url: "/api/v1/classes",
        method: "get",
        params: { page: this.page, limit: this.limit },
      }).then((res) => {
        if (res.status == 200) {
          this.loaded = true;
          this.dataTable = res.data.classes;
          if (res.data.total) {
            this.total = res.data.total;
          }
        } else {
          this.loaded = true;
          this.$message.error(res.msg);
        }
      });
    },
    choosetype(index, type) {
      if (type == 1) {
        this.active1 = index;
      } else if (type == 2) {
        this.active2 = index;
      } else if (type == 3) {
        this.active3 = index;
      }
    },

    /**每页数 */
    handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.getdata();
    },
    /**当前页 */
    handleCurrentChange(val) {
      this.page = val;
      this.getdata();
    },
  },
};
</script>

<style lang="less" scoped>
.carousel {
  height: 450px;
  position: relative;
  .carousel-box,
  /deep/ .el-carousel__container {
    height: 100%;
  }
}
.carousel-img {
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.lable {
  float: left;
  color: rgba(0, 0, 0, 0.56);
  font-size: 14px;
  margin-right: 20px;
}
.all {
  float: left;
  margin-right: 10px;
  color: rgba(0, 0, 0, 0.56);
  font-size: 14px;
}
.wid {
  line-height: 36px;
  height: 36px;
}
.type-box {
  margin-bottom: 20px;
}
.cont {
  color: rgba(0, 0, 0, 0.56);
  margin-bottom: 10px;
  display: block;
  padding: 0 10px;
  float: left;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  margin-right: 10px;
  border-radius: 10px;
}
.tag {
  margin-bottom: 32px;
}
.sort {
  padding-bottom: 10px;
  min-height: 500px;
  .sortItem {
    height: 320px;
    margin-bottom: 15px;
  }
  .sort-img {
    height: 120px;
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
    .class-img {
      width: 100%;
      height: 120px;
      border-radius: 10px;
      transition: all 0.6s;
    }
    .class-img:hover {
      cursor: pointer;
      transform: scale(1.1);
    }
  }
  .price-box {
    float: left;
  }
  .class-box {
    float: right;
  }
  .sort-des {
    cursor: pointer;
    margin-top: 10px;
    margin-bottom: 9px;
    color: rgba(7, 17, 27, 1);
    font-size: 16px;
    height: 48px;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .class-box {
    margin-top: 10px;
    width: 56px;
    height: 20px;
    text-align: center;
    color: rgba(42, 130, 228, 1);
    background-color: rgba(42, 130, 228, 0.2857142857142857);
    border-radius: 2px;
    font-size: 11px;
  }
}
.timeArea {
  font-size: 14px;
  padding: 10px 0;
}
.active {
  color: rgba(242, 13, 13, 0.7);
  background-color: rgba(242, 13, 13, 0.06);
}
</style>
